export default {"src":"/_next/static/media/EIX.28cc2a9b.svg","height":18,"width":18};